import { lazy, type ComponentType } from "react";
import { loadPageModule } from "./asset-recovery";
import type { PUBLIC_ROUTES } from "@shared/public-routes";

// Keep page modules out of the initial browser bundle. Server rendering supplies
// synchronous components from server/page-components.ts instead.
const loaders = {
  Landing: () => import("@/pages/landing"),
  MarketingPage: () => import("@/pages/marketing"),
  Integrations: () => import("@/pages/integrations"),
  InfluencerReviewPage: () => import("@/pages/influencer-review"),
  AffiliateMonitoringPage: () => import("@/pages/affiliate-monitoring"),
  MarketingReviewPage: () => import("@/pages/marketing-review"),
  AcademyPage: () => import("@/pages/academy"),
  AnalyticsPage: () => import("@/pages/analytics"),
  AutomationsPage: () => import("@/pages/automations"),
  ComplianceIntelligencePage: () => import("@/pages/compliance-intelligence"),
  IndustriesHub: () => import("@/pages/industries"),
  IndustryHealthWellnessPage: () => import("@/pages/industry-health-wellness"),
  IndustryCannabisCbdPage: () => import("@/pages/industry-cannabis-cbd"),
  IndustryPage: () => import("@/pages/industry"),
  Trust: () => import("@/pages/trust"),
  Beta: () => import("@/pages/beta"),
  About: () => import("@/pages/about"),
  Contact: () => import("@/pages/contact"),
  Careers: () => import("@/pages/careers"),
  ResourceHub: () => import("@/pages/resources"),
  ProductUpdatesHub: () => import("@/pages/product-updates"),
  Privacy: () => import("@/pages/privacy"),
  Terms: () => import("@/pages/terms"),
  Unsubscribe: () => import("@/pages/unsubscribe"),
  CreatorComplianceGuide: () => import("@/pages/creator-compliance-guide"),
  BrandLiabilityCreatorPosts: () => import("@/pages/brand-liability-creator-posts"),
  OnboardingCreatorCohort: () => import("@/pages/onboarding-a-creator-cohort"),
  MonthlyCreatorComplianceReview: () => import("@/pages/monthly-creator-compliance-review"),
  EscalationPlaybook: () => import("@/pages/escalation-playbook"),
  ResourceArticle: () => import("@/pages/resource-article"),
  ProductUpdateArticle: () => import("@/pages/product-update-article"),
  NotFound: () => import("@/pages/not-found"),
};

export type PageComponents = Record<keyof typeof loaders, ComponentType>;

const publicPageNames = {
  "/": "Landing",
  "/platform": "MarketingPage",
  "/platform/integrations": "Integrations",
  "/influencer-review": "InfluencerReviewPage",
  "/affiliate-monitoring": "AffiliateMonitoringPage",
  "/solutions/marketing-review": "MarketingReviewPage",
  "/academy": "AcademyPage",
  "/platform/analytics": "AnalyticsPage",
  "/platform/automations": "AutomationsPage",
  "/platform/compliance-intelligence": "ComplianceIntelligencePage",
  "/solutions/marketing-teams": "MarketingPage",
  "/solutions/compliance-regulatory": "MarketingPage",
  "/solutions/creator-marketing": "MarketingPage",
  "/solutions/agencies": "MarketingPage",
  "/industries": "IndustriesHub",
  "/industries/health-wellness": "IndustryHealthWellnessPage",
  "/industries/beauty-cosmetics": "IndustryPage",
  "/industries/finance-fintech": "IndustryPage",
  "/industries/alcohol-spirits": "IndustryPage",
  "/industries/gambling-gaming": "IndustryPage",
  "/industries/cannabis-cbd": "IndustryCannabisCbdPage",
  "/industries/fitness-activewear": "IndustryPage",
  "/industries/apparel-fashion": "IndustryPage",
  "/industries/food-beverage": "IndustryPage",
  "/industries/retail-cpg": "IndustryPage",
  "/trust": "Trust",
  "/demo": "Beta",
  "/about": "About",
  "/contact": "Contact",
  "/careers": "Careers",
  "/resources": "ResourceHub",
  "/product-updates": "ProductUpdatesHub",
  "/privacy": "Privacy",
  "/terms": "Terms",
  "/unsubscribe": "Unsubscribe",
} as const satisfies Record<keyof typeof PUBLIC_ROUTES, keyof PageComponents>;

export const ARTICLE_PAGE_NAMES = {
  "/resources/creator-marketing-compliance-guide": "CreatorComplianceGuide",
  "/resources/who-is-liable-for-influencer-marketing-claims": "BrandLiabilityCreatorPosts",
  "/resources/tips-for-onboarding-creators": "OnboardingCreatorCohort",
  "/resources/monthly-creator-compliance-review": "MonthlyCreatorComplianceReview",
  "/resources/escalation-playbook": "EscalationPlaybook",
  "/resources/:slug": "ResourceArticle",
  "/product-updates/:slug": "ProductUpdateArticle",
} as const satisfies Record<string, keyof PageComponents>;

export const routeNames = { ...publicPageNames, ...ARTICLE_PAGE_NAMES, "*": "NotFound" } as const;
export type PageRoutes = Record<keyof typeof routeNames, ComponentType>;

export function createPageRoutes(components: PageComponents): PageRoutes {
  return Object.fromEntries(
    Object.entries(routeNames).map(([path, name]) => [path, components[name]]),
  ) as PageRoutes;
}

const lazyPages = {} as PageComponents;
for (const name of Object.keys(loaders) as (keyof PageComponents)[]) {
  lazyPages[name] = lazy(() => loadPageModule(loaders[name]));
}
export const CLIENT_PAGE_ROUTES = createPageRoutes(lazyPages);
